import { ProjSection, ProjHeader, ProjGrid, ProjCard, ProjDivImg } from "./designcss/projectcss";
import ImageGrid from "./gallery";

const Project = () => {
  return (
    <ProjSection>
      <ProjHeader>
        <h1>My Projects</h1>
        <p>
          A collection of Features, applications, Multimedia and AI-driven solutions I’ve
          built to solve real-world problems.
        </p>
      </ProjHeader>

      <ImageGrid />
    </ProjSection>
  );
};

export default Project;